var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"cell-line-one"},[_vm._v("Total Return: "+_vm._s(_vm.totalReturn)+"%")]),_c('span',{staticClass:"cell-line-two"},[_vm._v("Avg Return: "+_vm._s(_vm.avgReturn)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }